import React from "react";
import { socialMediaPagesLink } from "@/utils/constants/supportInfo";

function PetCommunityBanner() {
  return (
    <section className="flex items-start md:items-center md:justify-between flex-col md:flex-row p-[19px] md:py-[2rem] md:px-[3rem] bg-gradient-to-r from-[#FF7AF6] via-[#F5CA97] to-[#FCFFD1] rounded-2xl">
      <h2 className="text-[#050426] text-[1.625rem] lg:text-[2rem] font-bold w-[223px] md:w-auto">
        Join Our Pet Lovers Community
      </h2>

      <div className="flex items-center justify-between space-x-[1.625rem] min-[400px]:space-x-[2.625rem] w-full md:w-auto mt-[1rem] lg:mt-0">
        <p className=" text-[#050426] font-medium text-xl whitespace-nowrap">
          Let&apos;s do it! —
        </p>

        <a
          href={socialMediaPagesLink.facebookGroup}
          target="_blank"
          rel="noreferrer"
        >
          <button className="text-white font-semibold text-lg py-[1rem] px-[1.5rem] min-[400px]:py-[1.125rem] min-[400px]:px-[2rem] bg-gradient-to-r from-[#6197FF] via-[#084BCC] to-[#084BCC] rounded-full whitespace-nowrap hover:shadow-join-facebook-group-button transition-shadow duration-500">
            Facebook Group
          </button>
        </a>
      </div>
    </section>
  );
}
export default PetCommunityBanner;
